import AnalyticalServices from "../../pages/Analytical";
import { InternalUserRoles } from "../../constants/roles";
import BiotechIcon from "@mui/icons-material/Biotech";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/analytical";

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: AnalyticalServices,
  allowedRoles: InternalUserRoles,
  label: "Analytical Services",
  icon: () => <BiotechIcon fontSize="large" />,
  isCustomIcon: false,
  hasDivider: false,
};

export const analyticalServicesRoutes: { [key: string]: RouteConfig } = {
  analyticalServices: baseRoute,
};
